import {
  noVideo,
  noVideoReplay,
  playCircle,
  videoReplay
} from "@fdr/static-ui/Icons/icons";

export const iconType = {
  NOT_AVAILABLE_REPLAY: playCircle,
  STARTING_SOON_REPLAY: playCircle,
  FINISHED_REPLAY: playCircle,
  AVAILABLE_REPLAY: playCircle,
  NOT_AVAILABLE_NO_REPLAY: noVideo,
  STARTING_SOON_NO_REPLAY: videoReplay,
  FINISHED_NO_REPLAY: noVideoReplay,
  AVAILABLE_NO_REPLAY: videoReplay
};

export const videoMessages = {
  NOT_AVAILABLE_REPLAY: "Watch Replay",
  STARTING_SOON_REPLAY: "Watch Replay",
  FINISHED_REPLAY: "Watch Replay",
  AVAILABLE_REPLAY: "Watch Replay",
  NOT_AVAILABLE_NO_REPLAY: "Video not currently available at this track",
  STARTING_SOON_NO_REPLAY: "Live video starting soon",
  STARTING_SOON_NO_REPLAY_SHORT_COPY: "Starting soon",
  FINISHED_NO_REPLAY: "No replay available for this track",
  AVAILABLE_NO_REPLAY: "Watch Live"
};
